import { App, Auth0InternalAuthZ  } from 'recycle-frontend-core';

export { interpolate, getObjectByPath, evaluatePolishExpression } from 'recycle-frontend-core'

const authProvider = new Auth0InternalAuthZ({
    grant_type: 'password',
    audience: "https://services.a2d24.com",
    scope: 'openid',
    client_id: "enTdh158WfEw44n7vnjvZnaF9H72YsK0",
    endpoint: 'https://a2d24.eu.auth0.com',
    connection: 'Username-Password-Authentication',
    authorization_endpoint: `${process.env.REACT_APP_API_ENDPOINT}/authorize`
});

const fetchConfig = {
    routes: () => null
}
const Recycle = new App(
    authProvider,
    process.env.REACT_APP_API_ENDPOINT,
    fetchConfig,
);
export default Recycle;